module.exports = __webpack_public_path__ + "static/img/treasure_bottom.b45eac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/treasure_bottom.jpg
// module id = 279
// module chunks = 6